import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { faCircleCheck as faCheck } from "@duocards/pro-solid-svg-icons";
import {
  Container,
  Grid,
  Row,
  Label,
  WhiteCell,
  Cell,
  IconContainer,
  CheckIcon,
  Dash,
  HeaderRow
} from "./PaywallComparisonGrid.styled";

type Feature = {
  name: string;
  free: boolean;
  premium: boolean;
};

// Main Component
const AdPaywallComparisonGrid: FC = () => {
  const { t } = useTranslation();

  const features: Feature[] = useMemo(
    () => [
      { name: t("Essential card learning"), free: true, premium: true },
      { name: t("Faster learning"), free: false, premium: true },
      { name: t("Unlimited number of cards"), free: false, premium: true },
      { name: t("No ad interruptions"), free: false, premium: true },
      { name: t("Learning with AI assistant"), free: false, premium: true }
    ],
    [t]
  );

  return (
    <Container>
      <Grid>
        <HeaderRow />
      </Grid>
      <Grid>
        {features.map((feature, index) => (
          <Row key={feature.name}>
            <Label>{feature.name}</Label>
            <Cell>
              {feature.free ? (
                <IconContainer>
                  <CheckIcon icon={faCheck} />
                </IconContainer>
              ) : (
                <Dash />
              )}
            </Cell>
            <WhiteCell>
              <Cell $isPremium $isLast={index === features.length - 1}>
                {feature.premium ? (
                  <IconContainer>
                    <CheckIcon icon={faCheck} $isPremium />
                  </IconContainer>
                ) : (
                  <Dash />
                )}
              </Cell>
            </WhiteCell>
          </Row>
        ))}
      </Grid>
    </Container>
  );
};

export default AdPaywallComparisonGrid;
